import React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

export interface QuickConfirmDlgProps {
  isOpen: boolean
  title: string
  message: string
  onOk: () => void
  onCancel: () => void
  okText?: string
  cancelText?: string
}

export const QuickConfirmDlg: React.FC<QuickConfirmDlgProps> = ({
  isOpen,
  title,
  message,
  onOk,
  onCancel,
  okText = "OK",
  cancelText = "Cancel",
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onCancel} // Or a specific handleClose if different from onCancel
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          {cancelText}
        </Button>
        <Button onClick={onOk} color="primary" autoFocus>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
